const iriPattern = new RegExp('/api/(?<type>.+?)/(?<id>.+)$', 'i')

/**
 * checks if given string is valid IRI by format
 */
export function isIri(possibleIri: string | undefined, iriPrefix?: string): boolean {
  if (!possibleIri) return false
  if (iriPrefix) return possibleIri.toLowerCase().startsWith(iriPrefix.toLowerCase())
  return iriPattern.test(possibleIri)
}

// export function iri2id(iri: string): string
// export function iri2id(iri: string[]): string[]
//
// // Overloads
// export function iri2id(iri: string): string
// export function iri2id(iri: string[]): string[]
// export function iri2id(iri: string, asNumber?: true): number
// export function iri2id(iri: string[], asNumber?: true): number[]
export function iri2id(iri: string, asNumber?: false): string
export function iri2id(iri: string[], asNumber?: false): string[]
export function iri2id(iri: string, asNumber: true): number
export function iri2id(iri: string[], asNumber: true): number[]
// Implementierung
export function iri2id(iri: string | string[], asNumber = false): string | string[] | number | number[] {
  if (Array.isArray(iri)) {
    // Falls ein Array übergeben wird, mappe jedes Element
    // Unterscheide explizit zwischen String- und Number-Konvertierung
    return asNumber ? iri.map((d) => iri2id(d, true)) : iri.map((d) => iri2id(d))
  }

  // Einzelnes IRI verarbeiten
  const id = fromIri(iri)?.id
  if (!id) {
    debugger
    throw new Error(`Iri2Id failed with input '${iri}'`)
  }

  // Konvertiere zu Zahl, falls erforderlich
  if (asNumber) {
    const numId = Number(id)
    if (isNaN(numId)) {
      debugger
      throw new Error(`Iri2Id failed to convert input '${iri}' to a number`)
    }
    return numId
  }

  return id
}

/**
 * Parses an IRI to id, type and iri - if possible
 */

export function fromIri<TId extends string | number>(iri: string): { id: TId; type: string; iri: string } | undefined {
  if (!isIri(iri)) return undefined
  const match = iriPattern.exec(iri)
  if (!match?.groups) return undefined
  const mGroups = match.groups
  return {
    id: mGroups.id as TId,
    type: mGroups.type,
    iri: mGroups.iri
  }
}

export function getIdFromIri(iri: string | undefined) {
  if (!iri || !isIri(iri)) return undefined
  const parts = fromIri(iri)
  return parts?.id
}

/**
 * Creates an iri by supplied id and iri prefix
 */

export function createIri<TId extends string | number | undefined | null>(id: TId, iriPrefix: string): string | undefined {
  if (!iriPrefix.trim()) return undefined
  if (id === undefined || id === null) return undefined
  let prefix: string
  if (iriPrefix.endsWith('/')) prefix = iriPrefix
  else prefix = `${iriPrefix}/`
  const iri = `${prefix}${id}`
  if (isIri(iri)) return iri
  return undefined
}

/**
 * Tries to get infos from IRI or id and prefix
 */
export function fromIriOrId<TId extends string | number>(
  idOrIri: TId | string,
  iriPrefix: string
):
  | {
      id: TId
      iri?: string
      type?: string
    }
  | undefined {
  if (!idOrIri) return undefined

  // Handle case when idOrIri is a valid IRI
  if (typeof idOrIri === 'string' && isIri(idOrIri)) {
    const iriData = fromIri(idOrIri)
    if (!iriData) return undefined

    return {
      id: iriData.id as TId, // Explicit cast to ensure TId compatibility
      iri: iriData.iri,
      type: iriData.type
    }
  }

  // Handle case when idOrIri is an ID
  if (typeof idOrIri === 'string' || typeof idOrIri === 'number') {
    const iri = createIri(idOrIri, iriPrefix)
    if (!iri) return undefined

    const iriType = fromIri(iri)?.type
    return {
      id: idOrIri as TId,
      iri,
      type: iriType
    }
  }

  // Return undefined for unsupported types
  return undefined
}
